import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const QuickAddBar = ({ projects, onAdd }) => {
  const [text, setText] = useState('');
  const [projectId, setProjectId] = useState('none');

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    const ok = await onAdd(text.trim(), projectId === 'none' ? null : projectId);
    if (ok) setText('');
  };

  return (
    <form onSubmit={submit} className="flex flex-col md:flex-row gap-2 bg-white border border-stone-200 rounded-lg p-3" data-testid="quick-add-bar">
      <Input value={text} onChange={e => setText(e.target.value)} placeholder="Quick job… e.g. Call plumber about kitchen sink point"
        data-testid="quick-add-input" className="flex-1 border-stone-200" />
      <Select value={projectId} onValueChange={setProjectId}>
        <SelectTrigger className="md:w-60 border-stone-200" data-testid="quick-add-project-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">General (no project)</SelectItem>
          {projects.map(p => <SelectItem key={p.project_id} value={p.project_id}>{p.project_name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button type="submit" disabled={!text.trim()} data-testid="quick-add-btn" className="bg-amber-700 hover:bg-amber-800 text-white">
        <Plus className="w-4 h-4 mr-1" /> Add
      </Button>
    </form>
  );
};
